
// alert(bottleOOS);



(function ($) {
  // Define a class-like object using jQuery style
  window.FonCartDrawer = {
    productData: [],
    test: function(){
      alert('test');
    },
    init: function(){


        var cartFbtSwiper = new Swiper('.swiper-fon-cart-fbt', {
          slidesPerView: 1.15,
          spaceBetween: 8,
          // autoplay: {
          //   delay: 5000, // ⏱ 5 seconds
          //   disableOnInteraction: false // 🔁 Keeps autoplay even after interaction
          // },
          breakpoints: {
            0: {
              slidesPerView: 1
            },
            768: {
              slidesPerView: 1.35
            }
          }
        });
        

      
        FonCartDrawer.clearBottle();
        FonCartDrawer.updateCartCount();
        FonCartDrawer.productData = JSON.parse(document.getElementById('productSellingPlanData').textContent);
      
        $(document).on('click','.fon-cart-heading-row .fon-cart-close',function(){
          $('body').removeClass('body-fon-cart-drawer');
        });


        $(document).on('change','.fon-qty',function(){
          
          var inputValue = parseInt($(this).val());
          var lineKey = $(this).closest('.fon-line-item-row').data('line-key');
          inputValue = inputValue;

          if (inputValue === 0){
            if (confirm('Do you want to remove this item?')) {
              FonCartDrawer.removeCartItem(lineKey);
            }else{
              $(this).val(1);
            }
          }else{


            // Multiplier
            var parentQuantity = $(this).parents('.fon-quantity');
            if (parentQuantity.data('multiple')){
              inputValue*= parseInt(parentQuantity.data('multiple'));
            }

            // Check if bundle
            var parent = $(this).parents('.fon-line-item-row');
            if (parent.find(".fon-less-btn").hasClass('fon-qty-bundle-btn')){

              var bundleID = parent.attr('data-bundle-group-id');
              FonCartDrawer.updateCartBundleItem(bundleID,inputValue);

              

            }else{

              FonCartDrawer.updateCartItem(lineKey, inputValue);

            }

            
          }
          
        });
      
        $(document).on('click','.fon-line-item-row.fon-line-item-bundle-row .fon-trash-bin',function(){
          

        });

        $(document).on('click','.fon-quantity button.fon-qty-btn',function(){

          if ($(this).hasClass('fon-qty-bundle-btn')){

            var parent = $(this).parents('.fon-line-item-row');
            var bundleID = parent.attr('data-bundle-group-id');
            var input = $(this).siblings('input');
            var inputValue = parseInt(input.val());


           
            var action = $(this).attr('data-action');
        
            switch (action){
              case 'minus':
                
                
                if (inputValue === 1){
                  if (confirm('Do you want to remove this item?')) {
                    FonCartDrawer.updateCartBundleItem(bundleID,0);
                  }
                }else{

                  var inputValueToReplace = inputValue;


                  inputValue--;
                  input.val(inputValue);

                  // fon qty parent / multiplier support
                  var parentQuantity = $(this).parents('.fon-quantity');
                  if (parentQuantity.data('multiple')){
                    inputValueToReplace*= parentQuantity.data('multiple'); //3;
                    inputValueToReplace-= parseInt(parentQuantity.data('multiple'));
                  }else{
                    inputValueToReplace--; // March 7
                  }


                  FonCartDrawer.updateCartBundleItem(bundleID,inputValueToReplace);
                }
                
              break;
              case 'plus':
                
                inputValue++;
                input.val(inputValue);


                 // fon qty parent / multiplier support
                var parentQuantity = $(this).parents('.fon-quantity');
                if (parentQuantity.data('multiple')){
                  inputValue*= parseInt(parentQuantity.data('multiple'));
                }


                FonCartDrawer.updateCartBundleItem(bundleID,inputValue);
                
              break;
            }


          }else{
            var parent = $(this).parents('.fon-line-item-row');
            
            var input = $(this).siblings('input');
            var inputValue = parseInt(input.val());
            var lineKey = $(this).closest('.fon-line-item-row').data('line-key');
            inputValue = inputValue;
        
            var action = $(this).attr('data-action');
        
            switch (action){
              case 'minus':
                
                
                if (inputValue === 1){
                  if (confirm('Do you want to remove this item?')) {
                    FonCartDrawer.removeCartItem(lineKey);
                  }
                }else{
                  inputValue--;
                  input.val(inputValue);
                  FonCartDrawer.updateCartItem(lineKey, inputValue);
                }
                
              break;
              case 'plus':
                
                inputValue++;
                input.val(inputValue);
                FonCartDrawer.updateCartItem(lineKey, inputValue);
                
              break;
            }

            if (parent.find('.fon-line-item-subscribe-save.active').length){
              
            }

            
          }
      
          
        });
      
        $(document).on('click','.fon-line-item-subscribe-save:not(.checked)',function(){
            $(this).toggleClass('active');
        });

      // Convert to One-time
        $(document).on('click', '.fon-line-item-subscribe-save.checked', function () {

          $('body').addClass('fon-cart-drawer-updating');
          var $clickedOption = $(this);
          var $row = $clickedOption.closest('.fon-line-item-row');
          // Get data
          var lineKey = $row.data('line-key'); // from cart.item.key
          var quantity = parseInt($row.find('.fon-qty').val(), 10) || 1;
          
          

          if ($row.hasClass('fon-line-item-row-12-months')){

            let productID = $row.attr('data-product-id');
            let sku = $row.attr('data-sku');
            let matchedVariant;
            
            FonCartDrawer.productData.forEach(product => {
  
              // Loop through product variants and check allocations
              product.variants.forEach(variant => {

                console.log('variant',variant);
                
                if (variant.sku == sku){
                  matchedVariant = variant;
                }
              });
            });

            console.log('matchedVariant',matchedVariant);
            console.log('sku',sku);

            FonCartDrawer.swapCartItem(lineKey,matchedVariant.id,quantity);
            
          }else{
          
            if (!lineKey || quantity < 1) {
              console.warn('Missing lineKey, or invalid quantity');
              return;
            }
          
            // Update cart item
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                id: lineKey,
                quantity: quantity,
                selling_plan: null
              },
              success: function (cart) {
                console.log('Updated selling plan:', cart);
                FonCartDrawer.updateCartDrawer(); // Refresh the UI
              },
              error: function (err) {
                console.error('Failed to update cart item:', err);
              }
            });
          }
        
          

        });



        // Convert to Monthly - New Cart
$(document).on('click', '.fon-line-item-wrapper button.btn-upgrade-bundle', function () {

  $('body').addClass('fon-cart-drawer-updating');

  var $thisBtn = $(this);
  $thisBtn.html('Upgrading...');

  var $row = $(this).closest('.fon-line-item-row');
  var bundleGroupID = $row.attr('data-bundle-group-id');
  
  let inclusions = [];
  
  // 1️⃣ Collect variants and new selling plans
  $row.find('.inclusion-variant').each(function() {
    inclusions.push({
      plan_id: parseInt($(this).attr('data-plan-id')),
      variant_id: parseInt($(this).attr('data-variant-id')),
      quantity: parseInt($(this).attr('data-quantity')),
    });
  });

  console.log('inclusions', inclusions);

  // 2️⃣ Fetch the current cart
  $.getJSON('/cart.js', function(cart) {
    let itemsToRemove = [];
    let itemsToAdd = [];

    // 3️⃣ Find bundle items
    $.each(cart.items, function(i, item) {
      if (item.properties && item.properties._bundle_group_id == bundleGroupID) {
        const inclusion = inclusions.find(inc => inc.variant_id == item.variant_id);
        if (inclusion) {
          itemsToRemove.push(item.key);

          // Copy all properties
          let newProps = $.extend(true, {}, item.properties);

          // 4️⃣ Build re-add object
          itemsToAdd.push({
            id: item.variant_id,
            quantity: inclusion.quantity || item.quantity,
            selling_plan: inclusion.plan_id,
            properties: newProps
          });
        }
      }
    });

    if (!itemsToAdd.length) {
      console.warn('No matching bundle items found to update.');
      $thisBtn.html('Upgrade');
      $('body').removeClass('fon-cart-drawer-updating');
      return;
    }

    // 🔁 Helper: remove one by one sequentially
    function removeItemsSequentially(keys, index = 0) {
      if (index >= keys.length) return $.Deferred().resolve().promise();
      return $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: keys[index], quantity: 0 },
        dataType: 'json'
      }).then(function() {
        // Chain next removal
        return removeItemsSequentially(keys, index + 1);
      });
    }

    // 5️⃣ Remove bundle items sequentially, then add back
    removeItemsSequentially(itemsToRemove).then(function() {
      console.log('All old bundle items removed, adding new ones...');
      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: itemsToAdd }),
        contentType: 'application/json',
        dataType: 'json'
      });
    }).done(function(updatedCart) {
      console.log('✅ Bundle converted successfully:', updatedCart);
      $thisBtn.html('Upgrade');
     
      if (window.FonCartDrawer && FonCartDrawer.updateCartDrawer) {
        FonCartDrawer.updateCartDrawer();
      } else {
        location.reload();
      }
    }).fail(function(err) {
      console.error('❌ Error converting bundle:', err);
      $thisBtn.html('Upgrade');
      $('body').removeClass('fon-cart-drawer-updating');
    });
  });
});




        $(document).on('click', '.fon-line-item-wrapper button.btn-upgrade', function () {

          $('body').addClass('fon-cart-drawer-updating');

          var $row = $(this).parents('.fon-line-item-row');
          
      
          var lineKey = $row.data('line-key'); // from cart.item.key
          var sellingPlanId = $(this).data('plan-id');
          var quantity = parseInt($row.find('.fon-qty').val(), 10) || 1;
        
          if (!lineKey || !sellingPlanId || quantity < 1) {
            console.warn('Missing lineKey, sellingPlanId, or invalid quantity');
            return;
          }
        
          // Update cart item
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: lineKey,
              quantity: quantity,
              selling_plan: sellingPlanId
            },
            success: function (cart) {
              console.log('Updated selling plan:', cart);
              FonCartDrawer.updateCartDrawer(); // Refresh the UI
            },
            error: function (err) {
              console.error('Failed to update cart item:', err);
            }
          });
          

        });


        // Convert to Monthly
        $(document).on('click', '.fon-save-option .fon-toggle-box, .fon-save-option .fon-badge', function () {

          $('body').addClass('fon-cart-drawer-updating');

          var $clickedOption = $(this).parents('.fon-save-option');
          var $row = $clickedOption.closest('.fon-line-item-row');
          
          if ($clickedOption.hasClass('fon-save-option-12-months')){
            
            
              var lineKey = $row.attr('data-line-key');
              var quantity = $clickedOption.attr('data-quantity');
              var variantID = $clickedOption.attr('data-variant-id');
              var sellingPlanID = $clickedOption.attr('data-selling-plan-id');
            

              FonCartDrawer.swapCartItem(lineKey,variantID,quantity,sellingPlanID);
              
            
          }else{

              // Regular selling plan
         
              // Toggle active state
              $row.find('.fon-save-option').removeClass('active');
              $clickedOption.addClass('active');
            
              // Get data
              var lineKey = $row.data('line-key'); // from cart.item.key
              var sellingPlanId = $clickedOption.data('selling-plan-id');
              var quantity = parseInt($row.find('.fon-qty').val(), 10) || 1;
            
              if (!lineKey || !sellingPlanId || quantity < 1) {
                console.warn('Missing lineKey, sellingPlanId, or invalid quantity');
                return;
              }
            
              // Update cart item
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                  id: lineKey,
                  quantity: quantity,
                  selling_plan: sellingPlanId
                },
                success: function (cart) {
                  console.log('Updated selling plan:', cart);
                  FonCartDrawer.updateCartDrawer(); // Refresh the UI
                },
                error: function (err) {
                  console.error('Failed to update cart item:', err);
                }
              });
          }

          

        });

        
    },
    updateCartBundleItem: function(bundleID,quantity){
      $('body').addClass('fon-cart-drawer-updating');
      $.getJSON('/cart.js', function(cart) {
        let updates = {};

        // Build an updates object where bundled items have quantity = 0
        $.each(cart.items, function(i, item) {


          var itemQuantity = quantity;

          

          if (item.properties && item.properties._bundle_group_id && item.properties._bundle_group_id == bundleID) {


            // If multiplier exist, multiple the base qty
            if (item.properties._bundle_group_product_multiplier) {
              itemQuantity*= item.properties._bundle_group_product_multiplier;
            }

            updates[item.key] = itemQuantity; // Mark for removal
          }


        });

        // If there are any items to remove, send one bulk update
        if (Object.keys(updates).length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { 
              updates: updates,
              discount : '',
            },
            dataType: 'json',
            success: function() {
              // Once done, refresh your custom cart drawer
              FonCartDrawer.updateCartDrawer();
            }
          });
        } else {
          // No bundled items found — just refresh drawer
          FonCartDrawer.updateCartDrawer();
        }
      });
    },
    swapCartItem: async function(oldItemKey, newVariantId, quantity = 1, sellingPlanId = null) {
      try {
        // 1. Remove old item
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: oldItemKey,
            quantity: 0
          })
        });
    
        // 2. Prepare add payload
        const addPayload = {
          id: newVariantId,
          quantity: quantity
        };
    
        if (sellingPlanId) {
          addPayload.selling_plan = sellingPlanId;
        }
    
        // 3. Add new product (with optional selling plan)
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addPayload)
        });
    
        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          throw new Error('Add failed: ' + errorText);
        }
    
        const addedItem = await addResponse.json();
    
        // ✅ 4. Trigger next step
        console.log('Swap complete:', addedItem);
        FonCartDrawer.updateCartDrawer(); // Refresh the UI
        
    
      } catch (error) {
        console.error('Swap failed:', error);
      }
    },
    clearFreeItems: function(variantIds = [], label = 'Item') {
      $.getJSON('/cart.js', function(cart) {


        // var discountCode = '';
        // // 🔍 Check if any item has a property containing 'BUNDLE'
        // const bundleItems = cart.items.filter(item => {
        //   if (item.properties) {
        //     return Object.keys(item.properties).some(
        //       key => key.toUpperCase().includes('BUNDLE') ||
        //             String(item.properties[key]).toUpperCase().includes('BUNDLE')
        //     );
        //   }
        //   return false;
        // });

        // if (bundleItems.length > 0) {
        //   let names = bundleItems.map(i => i.title).join(', ');
        //   alert('BUNDLE item(s) found in cart: ' + names);
        // }else{
        //     alert('NO BUNDLE');
          
        //       // 🏷️ Get all discount codes from the cart
        //     const discountCodes = cart.discount_codes || [];

        //     // 🧹 Clean up codes: remove "Pouch and Sachets / Subscription"
        //     const filteredDiscounts = discountCodes
        //       .map(d => d.code || d) // normalize to string
        //       .filter(code => code.toUpperCase() !== 'POUCH AND SACHETS / SUBSCRIPTION');

        //     // 🎯 Return only the first code if multiple exist
        //     discountCode = filteredDiscounts.length > 1 ? filteredDiscounts[0] : filteredDiscounts[0] || '';
              

        // }


        let itemsToRemove = cart.items.filter(i => variantIds.includes(i.variant_id));
        
        if (itemsToRemove.length > 0) {
          // Build updates: set quantity to 0 for each matching item
          let updates = {};
          itemsToRemove.forEach(item => {
            updates[item.key] = 0;
          });

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              // discount: discountCode,
              updates: updates
            },
            dataType: 'json',
            success: function(updatedCart) {
              console.log(label + '(s) removed directly:', variantIds);
            },
            error: function(err) {
              console.error('Error removing ' + label + '(s):', err);
            }
          });
        } else {
          console.log(label + '(s) not in the cart — skipping removal.');
        }
      });
    },
    clearBottle: function(){
      FonCartDrawer.clearFreeItems([53301741289656, 51843757670584,51793029103800,52304276357304,52304251027640,52219844985016,53491544391864,52887363551416], 'Free Gift');

      //51793029103800 == e-book
      // $.getJSON('/cart.js', function(cart) {
      //   let bottleItem = cart.items.find(item => item.variant_id === 53301741289656);
        
      //   if (bottleItem) {
      //     $.ajax({
      //       type: 'POST',
      //       url: '/cart/change.js',
      //       data: {
      //         id: bottleItem.key, // safer to use item key
      //         quantity: 0
      //       },
      //       dataType: 'json',
      //       success: function(updatedCart) {
      //         console.log('Bottle removed directly.');
      //       },
      //       error: function(err) {
      //         console.error('Error removing bottle:', err);
      //       }
      //     });
      //   } else {
      //     console.log('Bottle is not in the cart — skipping removal.');
      //   }
      // });
    },
    // clearBottle: function(){
    //   $.ajax({
    //       type: 'POST',
    //       url: '/cart/change.js',
    //       data: {
    //         id: 53301741289656,
    //         quantity: 0
    //       },
    //       dataType: 'json',
    //       success: function(updatedCart) {
    //         console.log('Variant removed directly.');
    //         // Optionally refresh the cart UI
    //       },
    //       error: function(err) {
    //         console.error('Error:', err);
    //       }
    //   });
      
    // },
    updateCartCount: function(){
      // $.getJSON('/cart.js', function(cart) {
      //   var itemCount = cart.item_count;
      //   console.log('Cart item count:', itemCount);
      
      //   // Example: update a badge
      //   $('.cart-count-badge').text(itemCount);
      //   if (itemCount === 0){
      //     $('.cart-count-badge').hide();
      //   }else{
      //     $('.cart-count-badge').show();
      //   }
      // });
      $.getJSON('/cart.js', function(cart) {
        // Include items where _bundle_group_product_row == '1' OR the property is not set
        var filteredItems = cart.items.filter(item => 
            !item.properties || !('_bundle_group_product_row' in item.properties) || item.properties._bundle_group_product_row == '1'
        );
        var itemCount = filteredItems.length;

        console.log('Filtered cart item count:', itemCount);

        $('.cart-count-badge').text(itemCount);
        if (itemCount === 0){
          $('.cart-count-badge').hide();
        } else {
          $('.cart-count-badge').show();
        }
    });

    },

    updateCartItem: function (lineKey, quantity) {

      $('.fon-qty-btn').prop('disabled',true);
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineKey,
          quantity: quantity
        },
        dataType: 'json',
        success: function (cart) {
          $('.fon-qty-btn').prop('disabled',false);
          FonCartDrawer.updateCartDrawer(); // Refresh the UI
        },
        error: function (err) {
          console.error('Failed to update cart item:', err);
          $('.fon-qty-btn').prop('disabled',false);
        }
      });
    },

    removeCartItem: function(lineKey) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineKey, // use line item key instead of variant ID
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          FonCartDrawer.updateCartDrawer();
        },
        error: function(err) {
          console.error('Failed to remove item:', err);
        }
      });
    },
    openCartDrawer: function () {


      $('.fon-cart-line-items').html('');
      $('body').addClass('body-fon-cart-drawer with-cart-items');


    },

    computeCartItems: function () {
      
    },

    updateSellingPlanQuantity: function() {
      return new Promise((resolve, reject) => {

  
        $.getJSON('/cart.js', function(cart) {
          var updates = {};

          cart.items.forEach(function(item) {

            console.log('item',item);
            if (
              item.product_title == "Special Price Products" &&
              item.quantity >= 3
            ) {
              var newQty = Math.floor(item.quantity / 3);
              updates[item.key] = newQty;
            }
          });

          if (Object.keys(updates).length > 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function(updatedCart) {
                console.log('Updated quantities for 12-month Supply items.');
                resolve(); // ✅ Proceed only after update is done
              },
              error: function(err) {
                console.error('Bulk update error:', err);
                reject(err); // ❌ Catch error if needed
              }
            });
          } else {
            console.log('No 12-month Supply items with quantity > 3 found.');
            resolve(); // ✅ Nothing to update, still resolve
          }
        });
      });
    },


    awaitClearFreeItems: function(variantIds = [], label = 'Item') {
      return new Promise((resolve, reject) => {

        $.getJSON('/cart.js', function(cart) {
          // 1️⃣ Items to remove by variant_id
          let itemsToRemoveByVariant = cart.items.filter(i => variantIds.includes(i.variant_id));

          // 2️⃣ Items to remove by _cart_hidden: yes
          let itemsToRemoveHidden = cart.items.filter(i => 
            i.properties && i.properties._cart_hidden &&
            String(i.properties._cart_hidden).toLowerCase() === 'yes'
          );

          // Combine all items to remove (avoid duplicates)
          let allItemsToRemove = [...new Set([...itemsToRemoveByVariant, ...itemsToRemoveHidden])];

          if (allItemsToRemove.length > 0) {
            let updates = {};
            allItemsToRemove.forEach(item => {
              updates[item.key] = 0; // Remove by line item key
            });

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function(updatedCart) {
                console.log(label + '(s) removed directly:', allItemsToRemove.map(i => i.key));

                // ✅ After removal, clear cart drawer HTML and add body class
                $('.fon-cart-line-items').html('');
                $('body').addClass('body-fon-cart-drawer');

                resolve(); // Resolve promise after everything is done
              },
              error: function(err) {
                console.error('Error removing ' + label + '(s):', err);
                reject(err);
              }
            });
          } else {
            console.log(label + '(s) not in the cart — skipping removal.');
            resolve();
          }
        });

      });
    },


    // awaitClearFreeItems: function(variantIds = [], label = 'Item') {
    //   return new Promise((resolve, reject) => {




    //     $.getJSON('/cart.js', function(cart) {

    //     let itemsToRemove = cart.items.filter(i => variantIds.includes(i.variant_id));
        
    //       if (itemsToRemove.length > 0) {
    //         // Build updates: set quantity to 0 for each matching item
    //         let updates = {};
    //         itemsToRemove.forEach(item => {
    //           updates[item.key] = 0;
    //         });

    //         $.ajax({
    //           type: 'POST',
    //           url: '/cart/update.js',
    //           data: {
    //             // discount: discountCode,
    //             updates: updates
    //           },
    //           dataType: 'json',
    //           success: function(updatedCart) {
    //             console.log(label + '(s) removed directly:', variantIds);
    //             resolve(); // ✅ Proceed only after update is done
    //           },
    //           error: function(err) {
    //             console.error('Error removing ' + label + '(s):', err);
    //             reject(err); // ❌ Catch error if needed
    //           }
    //         });
    //       } else {
    //         console.log(label + '(s) not in the cart — skipping removal.');
    //         resolve(); // ✅ Nothing to update, still resolve
    //       }
    //     });
      
    //   });
    // },
    // updateCartDrawer: function () {
    updateCartDrawer: async function () {

     await FonCartDrawer.updateSellingPlanQuantity();

     var itemsToRemoveJan26 = [53301741289656, 51843757670584,51793029103800,52887363551416,53301741289656,52304276357304,52304251027640,52219844985016];


     // ONeLife Bottles 52887363551416,53301741289656

     await FonCartDrawer.awaitClearFreeItems(itemsToRemoveJan26, 'Free Gift');

      $('.fon-line-item-free-bottle-row').remove();
      $('.fon-line-item-frother-bottle-row').remove();
      
      $('body').addClass('fon-cart-drawer-updating');
      $.getJSON('/cart.js', function (cart) {

          const applicableDiscounts = cart.discount_codes.filter(d => d.applicable);

          if (applicableDiscounts.length > 0) {
            const code = applicableDiscounts[0].code;
            console.log('Discount code applied:', code);
            $('.fon-cart-sub-total.fon-cart-sub-total-discount').css('display','flex');
            $('.fon-cart-sub-total.fon-cart-sub-total-discount .fon-checkout-discount').html(code);
          } else {
            console.log('No discount code applied.');
            $('.fon-cart-sub-total.fon-cart-sub-total-discount').hide();
          }
                  

        let html = '';


        




        var totalSubscriptionCount = 0;
        var totalBottle = 0;
        var totalFrother = 0;

        var totalWSWelcomeKit = 0;
        var totalWSBottle = 0;
        var totalWSFrother = 0;


        var totalOLBottle = 0;
        var totalOLFrother = 0;


        
        console.log('cart.js',cart);

        

        var item_count = cart.item_count;
        if (item_count === 0){
          $('p.fon-total-items').html('');
        }else{
          $('p.fon-total-items').html(`(${item_count} Items)`);
        }


        if (cart.items.length > 0) {


          var total = cart.total_price / 100;

          var formattedTotal = (total % 1 === 0)
          ? total.toFixed(0)
          : total.toFixed(2);

          $('.fon-checkout-total').html(
            '<span class="with-currency-code">' + formattedTotal + '</span>'
          );

          $('.fon-checkout-total-2').html(
            ' - <span class="with-currency-code">' + formattedTotal + '</span>'
          );

          // Make sure "empty" class is removed
          $('.fon-checkout-total').removeClass('empty');

        } else {
          // Handle empty cart
          $('.fon-checkout-total, .fon-checkout-total-2')
            .addClass('empty')
            .html('<span class="with-currency-code">0</span>');
        }


      // // Check if cart has items
      // if (cart.items.length > 0) {

      //   // Sum up all line item totals in the cart
      //   var totalCents = 0;
      //   cart.items.forEach(function(item) {
      //     totalCents += item.final_line_price; // Still in cents
      //   });

      //   // Convert from cents to dollars
      //   var total = totalCents / 100;

        

      //   // Format the price — remove .00 if not needed
      //   var formattedTotal = (total % 1 === 0)
      //     ? total.toFixed(0)
      //     : total.toFixed(2);

      //   // Update the checkout total element
      //   $('.fon-checkout-total').html(
      //     '<span class="with-currency-code">' + formattedTotal + '</span>'
      //   );

      //   // Make sure "empty" class is removed
      //   $('.fon-checkout-total').removeClass('empty');

      // } else {
      //   // Handle empty cart
      //   $('.fon-checkout-total')
      //     .addClass('empty')
      //     .html('<span class="with-currency-code">0</span>');
      // }

        var bundlesActive = [];

        var totalBundleBottle = 0;
        var totalBundleFrother = 0;
        $('.fon-cart-drawer').attr('data-bundle-bottle',totalBundleBottle);
        $('.fon-cart-drawer').attr('data-bundle-frother',totalBundleFrother);
        

        cart.items.forEach(function (item) {
          let originalPrice = item.original_line_price / 100;
          let finalPrice = item.final_line_price / 100;
          let finalPriceWS = item.final_line_price / 100;
          let hasDiscount = originalPrice > finalPrice;
          let discountAmount = (originalPrice - finalPrice).toFixed(2);
          let discountPercent = Math.round((1 - finalPrice / originalPrice) * 100);

          var paymentType = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : 'One-time Purchase';

          let productTitle = item.product_title;
          var hasBundle = false;

          if (item.properties && item.properties._BUNDLE) {
            hasBundle = true;

            // Bundle Freebies
            // if (item.properties._BUNDLE && item.properties._BUNDLE == 'The Starter'){
            //   totalFrother+=item.quantity;
            //   totalBottle+=item.quantity;
            // }


            // if (item.properties._BUNDLE && item.properties._BUNDLE == 'Ultimate Health' && item.properties._bundle_group_product_row == 1){
            //   totalFrother+=item.quantity;
            //   totalBottle+=item.quantity;
            // }

            // if (item.properties._BUNDLE && item.properties._BUNDLE == 'Pouch & Sachets' && item.properties._bundle_group_product_row == 1){
            //   totalFrother+=item.quantity;
            //   totalBottle+=item.quantity * 2;
            // }

          }

          

          if (item.properties && item.properties._BUNDLE && item.properties._bundle_group_id  && item.properties._bundle_group_product ) {

              var _bundle_group_id = item.properties._bundle_group_id;

              if (item.properties._bundle_group_product && !bundlesActive.includes(_bundle_group_id) && item.properties._bundle_group_product_row == 1) {
                

                


                var bundleSubscriptionInfo = '';
                var bundleSalePrice = parseFloat(item.properties._bundle_group_sale_price) * item.quantity;
                var bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price) * item.quantity;
                var bundleSave = bundleOGPrice - bundleSalePrice;

                bundleSave = bundleSave % 1 == 0 ? bundleSave.toFixed(0) : bundleSave.toFixed(2);
                
                var bundleSubscription = item.properties._bundle_group_payment_type;
                var bundleImage = item.properties._bundle_group_image;

                if (item.selling_plan_allocation){
                  bundleSubscriptionInfo = `
                    <p class="monthly-subscription-save">
                      <span class="with-currency-code">${bundleSalePrice}</span> - <span class="fon-monthly">Monthly Subscription (Save <span class="with-currency-code">${bundleSave}</span>)</span>
                    </p>
                  `;
                }

                var bundleInclusions = '';

                // Get Products   
                $.each(cart.items, function(i, item_inclusion) {

                  
                  if (item_inclusion.properties && item_inclusion.properties._bundle_group_id && item_inclusion.properties._bundle_group_id == _bundle_group_id) {

                    let bundleCleanedVariantTitle = (item_inclusion.variant_title) ? item_inclusion.variant_title
                      .replace("Pouches /", "")
                      .replace("Sachets /", "")
                      .trim() : item_inclusion.variant_title;


                    let bundleDiscountedPriceTotal = 0; 
                    let bundleBasePrice = 0; 
                    let bundleSaveTotalDiscount = 0;
                    let bundlePlanID = ''; 


                    // Selling Plan ID for Bundle Properties
                    // const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item_inclusion.product_id));
                    // const bundleCheckVariant = bundleProduct.variants.find(v => String(v.id) === String(item_inclusion.variant_id));
                    // const bundleCheckSellingPlans = bundleCheckVariant.selling_plans;

                    const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                    const bundleCheckVariant = bundleProduct?.variants?.find(v => String(v.id) === String(item.variant_id));
                    const bundleCheckSellingPlans = bundleCheckVariant?.selling_plans ?? [];



                    console.log('bundleCheckSellingPlans',bundleCheckSellingPlans);
                    

                    if (bundleProduct && bundleCheckSellingPlans){

                      let bundleVariant = bundleCheckVariant;
                      let bundleSellingPlans = bundleCheckSellingPlans;
                      
                        

                      bundleSellingPlans.forEach(plan => {

                        let displayName = plan.name === 'Ships every 30-days' ? 'Monthly Delivery' : plan.name;
                        let priceAdjustment = plan.adjustment_type;
                        let isPercentage = priceAdjustment === 'percentage';
                        let adjustmentValue = parseFloat(plan.price_adjustment);

                        bundleBasePrice = bundleCheckVariant.price;

                        // Compute discounted price
                        let discountedPrice = isPercentage
                          ? bundleBasePrice - (bundleBasePrice * (adjustmentValue / 100))
                          : bundleBasePrice - adjustmentValue;

                        bundleDiscountedPriceTotal = (discountedPrice - (discountedPrice * (discountPercent / 100))) * item_inclusion.quantity;
                        bundleBasePrice = Math.ceil(bundleBasePrice * item_inclusion.quantity);
                        bundleSaveTotalDiscount = bundleBasePrice - bundleDiscountedPriceTotal;

                        bundleDiscountedPriceTotal = bundleDiscountedPriceTotal % 1 == 0 ? bundleDiscountedPriceTotal.toFixed(0) : bundleDiscountedPriceTotal.toFixed(2);
                        bundleBasePrice = bundleBasePrice % 1 ===0 ? bundleBasePrice.toFixed(0) : bundleBasePrice.toFixed(2);
                        bundleSaveTotalDiscount = bundleSaveTotalDiscount % 1 == 0 ? bundleSaveTotalDiscount.toFixed(0) : bundleSaveTotalDiscount.toFixed(2);
                          
                        bundlePlanID = plan.id;
                      });
                    }
                    
                    let bundleCleanedPackaging = (item_inclusion.variant_title) ? (item_inclusion.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets' : ''; 
                    // let bundleCleanedPackaging = (item_inclusion.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets';
                    let bundleInclusionTitle = '';

                    switch (bundleCleanedVariantTitle){
                      case 'Cacao':
                      case 'French Vanilla':
                        bundleInclusionTitle = `1x OneFit Plant-based ${bundleCleanedPackaging}`;
                        bundleInclusionTitle+= ` - <span class="fon-cart-variant-title">${bundleCleanedVariantTitle}</span>`;
                        break;
                      case 'Sachets OneLife / Watermelon':
                        bundleInclusionTitle = `1x OneLife Original Sachets - <span class="fon-cart-variant-title">Watermelon</span>`;
                        break;
                      default:
                        bundleInclusionTitle = `1x OneFit Original ${bundleCleanedPackaging}`;
                        bundleInclusionTitle+= ` - <span class="fon-cart-variant-title">${bundleCleanedVariantTitle}</span>`;
                    }
                    bundleInclusions+=`
                      <span class="inclusion-item inclusion-variant" 
                      data-plan-id="${bundlePlanID}" 
                      data-variant-id="${item_inclusion.variant_id}" 
                      data-quantity="${item_inclusion.quantity}">${bundleInclusionTitle}</span>
                    `;
                  }
                });
                // Get Add Onds   
                $.each(cart.items, function(i, item_inclusion_add_ons) {

                  var bundleBottleIncluded = 0;
                  var bundleFrotherIncluded = 0;

                  if (
                    item_inclusion_add_ons.properties && 
                    item_inclusion_add_ons.properties._bundle_group_id && 
                    item_inclusion_add_ons.properties._bundle_group_id == _bundle_group_id && 
                    item_inclusion_add_ons.properties._bundle_group_product_row == 1) {

                    switch (item.properties._BUNDLE){
                      case 'The Starter':

                        bundleBottleIncluded = 1 * item_inclusion_add_ons.quantity;

                        // if (!frotherOOS){
                        //   bundleFrotherIncluded = 1 * item_inclusion_add_ons.quantity;
                        // }
                        
                        bundleInclusions+=`
                          <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        `;
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;

                      break;
                      case 'Pouch & Sachets':
                        
                        bundleBottleIncluded = 2 * item_inclusion_add_ons.quantity;

                        if (!frotherOOS){
                          bundleFrotherIncluded = 1 * item_inclusion_add_ons.quantity;
                        }
                        
                        bundleInclusions+=`
                          <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">2x Marathon Bottles</span>
                          <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        `;
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">2x Marathon Bottles</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;

                      break;

                      case 'Ultimate Health':
                        
                        bundleBottleIncluded = 1 * item_inclusion_add_ons.quantity;

                        if (!frotherOOS){
                          bundleFrotherIncluded = 1 * item_inclusion_add_ons.quantity;
                        }
                        
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;
                        bundleInclusions+=`
                          <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                          <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        `;

                      break;

                      case 'Weekly Billing':
                        
                        bundleBottleIncluded = 1 * item_inclusion_add_ons.quantity;

                        // if (!frotherOOS){
                        //   bundleFrotherIncluded = 1 * item_inclusion_add_ons.quantity;
                        // }
                        
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;

                      break;
                      case 'FON Welcome Kit':
                        
                        bundleBottleIncluded = 1 * item_inclusion_add_ons.quantity;

                        if (!frotherOOS){
                          bundleFrotherIncluded = 1 * item_inclusion_add_ons.quantity;
                        }
                        
                        bundleInclusions+=`
                          <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                          <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        `;
                        // bundleInclusions+=`
                        //   <span class="inclusion-item inclusion-item-add-on" data-bottle="${bundleBottleIncluded}">1x Marathon Bottle</span>
                        //   <span class="inclusion-item inclusion-item-add-on inclusion-frother-add-on" data-frother="${bundleFrotherIncluded}">1x FON Frother </span>
                        // `;

                      break;

                    }

                    totalBundleBottle+=bundleBottleIncluded;
                    totalBundleFrother+=bundleFrotherIncluded;

                  }
                });

                $('.fon-cart-drawer').attr('data-bundle-bottle',totalBundleBottle);
                $('.fon-cart-drawer').attr('data-bundle-frother',totalBundleFrother);


                
                
                
                // const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                // const bundleCheckVariant = bundleProduct.variants.find(v => String(v.id) === String(item.variant_id));
                // const bundleCheckSellingPlans = bundleCheckVariant.selling_plans;

                // Feb 2026
                const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                const bundleCheckVariant = bundleProduct?.variants?.find(v => String(v.id) === String(item.variant_id));
                const bundleCheckSellingPlans = bundleCheckVariant?.selling_plans ?? [];

                let bundleBasePrice =  bundleOGPrice % 1 == 0 ? bundleOGPrice.toFixed(0) : bundleOGPrice.toFixed(2);
                let bundleDiscountedPriceTotal = bundleSalePrice % 1 == 0 ? bundleSalePrice.toFixed(0) : bundleSalePrice.toFixed(2);
                let bundleSaveTotalDiscount = bundleBasePrice - bundleDiscountedPriceTotal;
                
                bundleSaveTotalDiscount = bundleSaveTotalDiscount % 1 == 0 ? bundleSaveTotalDiscount.toFixed(0) : bundleSaveTotalDiscount.toFixed(2);


                bundleOGPrice =  bundleOGPrice % 1 == 0 ? bundleOGPrice.toFixed(0) : bundleOGPrice.toFixed(2);
                bundleSalePrice = bundleSalePrice % 1 == 0 ? bundleSalePrice.toFixed(0) : bundleSalePrice.toFixed(2);
                
       

                switch (item.properties._BUNDLE){
                  

                  case 'onefit_90d_conquesting':

                    

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }

                    // Get Price Bundle
                    var uBundleQty = 0;
                    var uBundlePrice = 0;
                    var uBundleTitles = '';
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;
                        uBundleQty+= u_item.quantity;

                        uBundleTitles+='<span class="d-block">' + u_item.quantity + 'x ' + u_item.variant_title + '</span>'

                      }
                    });

                    var dataURL = '';
                    if (item.properties._order_from){
                      switch (item.properties._order_from){
                        case 'conquesting_onefit-vs-protein':
                          dataURL = '/pages/onefit-vs-protein';
                        break;
                        case 'conquesting_onefit-vs-collagen':
                          dataURL = '/pages/onefit-vs-collagen';
                        break;
                      }
                    }

                    var qtyBundle = uBundleQty / 5;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ;

                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneFit 90-Day Supply<span class="fw-400"><span class="variant-titles">${uBundleTitles}</span></span></h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${uBundleQty / 5}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${uBundleQty / 5}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'comprehensive_90d':

                    var qtyBundle = item.quantity / 5;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle ; 

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });

                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/comprehensive">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Comprehensive 90-Day Supply<span class="fw-400"><br>${item.variant_title}<br>OneLife</span></h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity / 5}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 5}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'comprehensive_365d':

                    var qtyBundle = item.quantity / 19;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle * 2 ; 

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });

                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/comprehensive">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Comprehensive 365-Day Supply<span class="fw-400"><br>${item.variant_title}<br>OneLife</span></h3>
                                <p>Billed Once</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity / 19}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 19}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'comprehensive_30d':

                    var qtyBundle = item.quantity / 2;
                    totalOLBottle+= qtyBundle;
                    totalOLFrother+= qtyBundle ; 

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });


                    var onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/comprehensive">
                              <div class="image">
                                <img class="img-fluid" src="${onefit60dImage}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Comprehensive 30-Day Supply<span class="fw-400"><br>${item.variant_title}<br>OneLife</span></h3>
                                <p>Ships every 30-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity / 3}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 2}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'unicorn_comprehensive_90d':

                    var qtyBundle = item.quantity / 5;
                    totalBottle+= qtyBundle * 2;
                    totalFrother+= qtyBundle ;

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });

                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/pages/homepage-quiz">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Full Body System (90 Days)<span class="fw-400 d-block mt-2">${item.variant_title}<br>OneLife</span></h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity / 5}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 5}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;

                  case 'unicorn_comprehensive_30d':

                    // var qtyBundle = item.quantity / 2;
                    // totalOLBottle+= qtyBundle;
                    // totalOLFrother+= qtyBundle ;

                    // If unicorn remove freebies
                    // if (item.properties._order_from && item.properties._order_from == 'comprehensive-unicorn'){
                    //   totalOLBottle = 0;
                    //   totalOLFrother = 0;
                    // }

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });


                    var onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    if (item.variant_title.includes("Pouch")) {
                        onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-new_onelifejar_onefit_d.jpg?v=1781842979';
                    }
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/pages/homepage-quiz">
                              <div class="image">
                                <img class="img-fluid" src="${onefit60dImage}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Full Body System (30 Days)<span class="fw-400 d-block mt-2">${item.variant_title}<br>OneLife</span></h3>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${uBundlePrice}">${uBundlePrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity / 3}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 2}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'unicorn_onefit_90d':

                    var qtyBundle = item.quantity / 5;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ; 

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/90-DAY-BUNDLE-BOX_NEW-BOTTLE_1000x.jpg?v=1780014785';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/90-DAY-BUNDLE-POUCH_NEW-BOTTLE_1_1000x.jpg?v=1780014848';
                    }
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/onefit-b">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneFit 90-Day Supply <br>${item.variant_title}</h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-multiple="5" data-qty="${item.quantity / 5}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 5}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'onefit_90d':

                    var qtyBundle = item.quantity / 5;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ; 

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/90-DAY-BUNDLE-BOX_NEW-BOTTLE_1000x.jpg?v=1780014785';
                    if (item.variant_title.includes("Pouch")) {
                        onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/90-DAY-BUNDLE-BOX_NEW-BOTTLE_1000x.jpg?v=1780014785';
                    }
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/onefit-b">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneFit 90-Day Supply <br>${item.variant_title}</h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-multiple="5" data-qty="${item.quantity / 5}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 5}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;


                  case 'onefit_60d':

                    var qtyBundle = item.quantity / 3;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ;

                    var onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/onefit-60d-sachets.png?v=1770876716';
                    if (item.variant_title.includes("Pouch")) {
                        onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneFit_90-Day_Supply.png?v=1770697811';
                    }
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/onefit-b">
                              <div class="image">
                                <img class="img-fluid" src="${onefit60dImage}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneFit 60-Day Supply<br>${item.variant_title}</h3>
                                <p>Ships every 60-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-multiple="3" data-qty="${item.quantity / 3}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 3}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;



                  case 'unicorn_onelife_90d':
                  case 'onelife_90d':

                    var qtyBundle = item.quantity / 3;
                    totalOLBottle+= qtyBundle;
                    totalOLFrother+= qtyBundle ;


                    var dataURL = '/products/onelife';
                    if (item.properties._order_from){
                      switch (item.properties._order_from){

                        case 'conquesting_onelife-vs-longevity':
                          dataURL = '/pages/onelife-vs-longevity';
                        break;
                        case 'conquesting_onelife-vs-nmn':
                          dataURL = '/pages/onelife-vs-nmn';
                        break;
                        case 'hybrid':
                          dataURL = '/pages/welcome-onelife';
                        break;
                        case 'pathway_onelife-unicorn':
                          dataURL = '/pages/homepage-quiz';
                        break;

                      }
                    }
                    

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-90-Day-Jar.jpg?v=1781851220" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife 90-Day Supply (Single)</h3>
                                <p>Ships every 90-days</p>

                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-multiple="3" data-qty="${item.quantity / 3}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 3}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  case 'onelife_90d_duo':

                    var qtyBundle = item.quantity / 6;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle * 2;


                    var dataURL = '/products/onelife';
                    if (item.properties._order_from){
                      switch (item.properties._order_from){

                        case 'conquesting_onelife-vs-longevity':
                          dataURL = '/pages/onelife-vs-longevity';
                        break;
                        case 'conquesting_onelife-vs-nmn':
                          dataURL = '/pages/onelife-vs-nmn';
                        break;

                        case 'hybrid':
                          dataURL = '/pages/welcome-onelife';
                        break;

                      }
                    }
                    

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife_90d_Duo_Product_Card.png?v=1781849497" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife 90-Day Supply (Duo)</h3>
                                <p>Ships every 90-days</p>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-multiple="6" data-qty="${item.quantity / 6}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity / 6}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  case 'onelife_30d':

                    var qtyBundle = item.quantity;
                    totalOLBottle+= qtyBundle;
                    

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/onelife-jar">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Onelife_transparent_1500x1500_dc16c241-f123-4722-a01f-bbdf310c94d4.png?crop=center&height=300&v=1760588451&width=300" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife 30-Day Supply</h3>
                                <p>Ships every 30-days</p>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity"  data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  case 'onelife_onetime':

                    var qtyBundle = item.quantity;
                    totalOLBottle+= 1;
                    totalOLFrother+= 1;
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/pages/welcome-onelife">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Onelife_transparent_1500x1500_dc16c241-f123-4722-a01f-bbdf310c94d4.png?crop=center&height=300&v=1760588451&width=300" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife (Try-It Once)</h3>
                                <p>1 Month of OneLife</p>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity"  data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  case 'The Starter':

                    

                      html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/the-starter">
                              <div class="image">
                                <img class="img-fluid" src="${bundleImage}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">The Starter</h3>
                                
                                <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${bundleInclusions}</div>
                                ${
                                  item.selling_plan_allocation
                                    ? ``
                                    : `
                                      <p class="price">
                                        <span class="price-new with-currency-code" data-item-final-price="${bundleOGPrice}">${bundleOGPrice}</span>
                                      </p>
                                    `
                                }
                                ${bundleSubscriptionInfo}
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            
                            ${ bundleProduct && bundleCheckVariant && bundleCheckSellingPlans.length && !item.selling_plan_allocation
                              ? `
                                <div class="fon-subscribe-save-wrapperx">
                                  <p class="fon-save-label">Subscribe & Save <span class="with-currency-code amount">${bundleSaveTotalDiscount}</span></p>
                                  <p class="pause-anytime"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_Anytime.svg?v=1760332895" alt="Pause Anytime"/> Pause, adjust flavours, cancel any time</p>
                                  <p class="prices">
                                    <span class="new with-currency-code">${bundleDiscountedPriceTotal}/mo</span>
                                    <span class="old">vs. <span class="with-currency-code"></span>${bundleBasePrice}</span>
                                  </p>
                                  <button class="btn-upgrade-bundle" type="button">Upgrade now</button>
                                </div>
                                `
                              : ''
                            }

                          </div>

                          

                        </div>
                      `;
                    break;

                  case 'Pouch & Sachets':
                      html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/pouch-sachets">
                              <div class="image">
                                <img class="img-fluid" src="${bundleImage}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">Pouch & Sachets</h3>
                                
                                <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${bundleInclusions}</div>
                                ${
                                 item.selling_plan_allocation
                                    ? ``
                                    : `
                                      <p class="price">
                                        <span class="price-new with-currency-code" data-item-final-price="${bundleOGPrice}">${bundleOGPrice}</span>
                                      </p>
                                    `
                                }
                                ${bundleSubscriptionInfo}
                                
                              </div>
                              <div class="action align-self-center justify-content-end">
                              

                                  <div class="fon-quantity" data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                </div>


                              </div>
                            </div>
                            ${ bundleProduct && bundleCheckVariant && bundleCheckSellingPlans.length && !item.selling_plan_allocation
                              ? `
                                <div class="fon-subscribe-save-wrapperx">
                                  <p class="fon-save-label">Subscribe & Save <span class="with-currency-code amount">${bundleSaveTotalDiscount}</span></p>
                                  <p class="pause-anytime"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_Anytime.svg?v=1760332895" alt="Pause Anytime"/> Pause, adjust flavours, cancel any time</p>
                                  <p class="prices">
                                    <span class="new with-currency-code">${bundleDiscountedPriceTotal}/mo</span>
                                    <span class="old">vs. <span class="with-currency-code"></span>${bundleBasePrice}</span>
                                  </p>
                                  <button class="btn-upgrade-bundle" type="button">Upgrade now</button>
                                </div>
                                `
                              : ''
                            }
                          </div>
                        </div>
                      `;
                    break;
                case 'Ultimate Health':
                    html+=`
                      <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                      >
                        <div class="fon-line-item-wrapper">
                          <div class="fon-line-item" data-url="/products/pouch-sachets">
                            <div class="image">
                              <img class="img-fluid" src="${bundleImage}" alt="">
                            </div>
                            <div class="text">
                              <h3 class="bundle-title">Ultimate Health</h3>
                              
                              <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${bundleInclusions}</div>
                              ${
                               item.selling_plan_allocation
                                  ? ``
                                  : `
                                    <p class="price">
                                      <span class="price-new with-currency-code" data-item-final-price="${bundleOGPrice}">${bundleOGPrice}</span>
                                    </p>
                                  `
                              }
                              ${bundleSubscriptionInfo}
                            </div>
                            <div class="action align-self-center justify-content-end">
                             

                                <div class="fon-quantity" data-qty="${item.quantity}">
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                              </div>


                            </div>
                          </div>
                          ${ bundleProduct && bundleCheckVariant && bundleCheckSellingPlans.length && !item.selling_plan_allocation
                              ? `
                                <div class="fon-subscribe-save-wrapperx">
                                  <p class="fon-save-label">Subscribe & Save <span class="with-currency-code amount">${bundleSaveTotalDiscount}</span></p>
                                  <p class="pause-anytime"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_Anytime.svg?v=1760332895" alt="Pause Anytime"/> Pause, adjust flavours, cancel any time</p>
                                  <p class="prices">
                                    <span class="new with-currency-code">${bundleDiscountedPriceTotal}/mo</span>
                                    <span class="old">vs. <span class="with-currency-code"></span>${bundleBasePrice}</span>
                                  </p>
                                  <button class="btn-upgrade-bundle" type="button">Upgrade now</button>
                                </div>
                                `
                              : ''
                            }
                        </div>
                      </div>
                    `;
                  break;


                  case 'Wholesale':

                        var retailerBundleQty = (item.quantity / 12);

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price) * retailerBundleQty;
                        let wholesaleProductQty = item.quantity;

                        totalWSWelcomeKit+= retailerBundleQty;
                        totalWSBottle+=5 * retailerBundleQty;
                        totalWSFrother+=5 * retailerBundleQty;

                        var retailerOneFitQty = retailerBundleQty * 12;


                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row fon-line-item-wholesale-row-kitx" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Portal_Welcome_Kit.png?v=1761797300" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">Retailers Essentials Bundle</h3>
                                  <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${retailerOneFitQty}x OneFit Sachet Boxes, ${retailerOneFitQty}x OneFit Pouches</div>
                                  
                                  
                                  ${
                                  item.selling_plan_allocation
                                      ? ``
                                      : `
                                        <p class="price">
                                          <span class="price-new with-currency-code" data-item-final-price="${bundleOGPrice}">${bundleOGPrice}</span>
                                        </p>
                                      `
                                  }
                                  ${bundleSubscriptionInfo}
                                </div>
                                <div class="action align-self-center justify-content-end">
                                

                                    <div class="fon-quantity" data-multiple-ws="12" data-qty="${ (item.quantity / 12 ) }">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${ (item.quantity / 12 ) }" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                    </div>
                                    


                                </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                      // <div class="fon-quantity" data-qty="1">
                      //               <input name="fon-qty" class="form-control fon-qty" type="number" value="1" min="0"/>
                      //               <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                      //               </div>
                                    

                      case 'Wholesale Mix & Match':

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price);
                        var mixMatch = item.quantity;
                        var wholesaleDescription = item.properties._bundle_group_description;

                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row fon-line-item-wholesale-row-mix" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Promo_Kit_Image.png?v=1762402294" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">Retailers Mix & Match</h3>
                                  ${ wholesaleDescription ? `<div class="lineitem-bundle-inclusions">${wholesaleDescription}</div>` : ``}
                                </div>
                                <div class="action align-self-center justify-content-end">
                                

                                    
                                    <div class="fon-quantity" data-qty="1">
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="1" min="0"/>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                    </div>
                                    


                                </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                      case 'Wholesale Product':

                        var isAccessory = false;
                        var wholesaleDescription = item.properties._bundle_group_description;
                        
                        // alert(productTitle);
                        // Get Title
                        if (  
                              productTitle.includes("Retailers") && item.variant_title && !item.variant_title.includes("Bottle") && !item.variant_title.includes("Frother")
                          ) {
                          let cleanedVariantTitle = item.variant_title
                            .replace("OneFit ", "")
                            .replace("Pouches /", "")
                            .replace("Sachets /", "")
                            .trim();


                          if (item.variant_title.includes('Sachets')){
                            if (item.variant_title.includes('Cacao') || item.variant_title.includes('French Vanilla')){
                              productTitle+= '<span class="wholesale d-block">OneFit Plant-based: Sachets <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }else{
                              productTitle+= '<span class="wholesale d-block">OneFit Original: Sachets <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }
                          }else{
                            if (item.variant_title.includes('Cacao') || item.variant_title.includes('French Vanilla')){
                              productTitle+= '<span class="wholesale d-block">OneFit Plant-based: Pouch <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }else{
                              productTitle+= '<span class="wholesale d-block">OneFit Original: Pouch <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }
                          }

                        }


                        if (  
                              productTitle.includes("Retailers") && item.variant_title &&  
                              (item.variant_title.includes("Promo Kit") || 
                              item.variant_title.includes("Bottle") || 
                              item.variant_title.includes("Frother") )
                          ) {
                          let cleanedVariantTitle = item.variant_title
                            .replace("OneFit ", "")
                            .replace("Pouches /", "")
                            .replace("Sachets /", "")
                            .replace("Accessories /", "")
                            .replace("Kits /", "")
                            .trim();

                          // wholesaleDescription = '';
                          productTitle = '';
                          productTitle+= `Retailers <span class="wholesale d-block"><span class="d-block fon-cart-variant-title">${item.quantity}x ${cleanedVariantTitle}</span</span>`;
                            isAccessory = true;
                        }

                        // Get Image
                        let productImage = item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_100x100_crop_center$1');
                        const product = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));

                        // let check_variant = product.variants.find(v => String(v.id) === String(item.variant_id));
                        // let check_sellingPlans = check_variant.selling_plans;

                        // Feb 23, 2026
                        let check_variant = (product?.variants ?? []).find(
                          v => String(v.id) === String(item.variant_id)
                        );


                        let check_sellingPlans = check_variant?.selling_plans ?? [];

                        // Product Thumbnail
                        // if (product){
                        //   let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
                        //   if (variant){
                        //     productImage = variant.thumbnail;
                        //   }
                        // }

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price);
                        
                        let wholesaleQuantity = item.quantity;

                        // totalWSWelcomeKit++;
                        // totalWSBottle+=5;
                        // totalWSFrother+=5;

                        // KITS - Promo Kit
                        if (productTitle.includes('Promo Kit')){
                          totalWSBottle+= item.quantity * 10;
                          totalWSFrother+= item.quantity * 10;
                        }


                        var wsProductQty = item.quantity / 6;


                        if (productTitle.includes('Sachets')){

                          if (wsProductQty == 1){
                            wholesaleDescription = `1 Carton = 6 × 20 sachets (120 total)`;
                          }else{
                            var wsProductTotal = item.quantity * 20;
                            wholesaleDescription = `${wsProductQty} Cartons = ${item.quantity} × 20 sachets (${wsProductTotal} total)`;
                          }
                          
                          isAccessory = false;
                        }
                        if (productTitle.includes('Pouch')){

                          if (wsProductQty == 1){
                            wholesaleDescription = `1 Carton = 6 Pouches (4.2 kgs in total)`;
                          }else{
                            var wsProductTotal = wsProductQty * 4.2;
                            wholesaleDescription = `${wsProductQty} = ${item.quantity} Pouches (${wsProductTotal} kgs in total)`;
                          }
                          isAccessory = false;

                        }

                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row ${ isAccessory ? 'fon-line-item-wholesale-accessory' : '' }" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                              
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="${productImage}" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">${productTitle}</h3>

                                  ${ wholesaleDescription ? `<div class="lineitem-bundle-inclusions">${wholesaleDescription}</div>` : ``}
                                  
                                  ${ originalPrice == finalPriceWS ? 
                                  
                                    `<p class="price">
                                          <span class="price-new with-currency-code" data-item-final-price="${finalPriceWS}">${finalPriceWS}</span>
                                        </p>`
                                    : 
                                      `<p class="price">
                                      <span class="price-old with-currency-code">${originalPrice}</span>
                                      <span class="price-new with-currency-code" data-item-final-price="${finalPriceWS}">${finalPriceWS}</span>
                                    </p>`
                                    
                                  }


                                  ${bundleSubscriptionInfo}
                                </div>
                                <div class="action align-self-center justify-content-end">
                                

                                    ${ isAccessory ? `
                                    <div class="fon-quantity" data-qty="${item.quantity}">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                    </div>
                                    ` : 
                                  `<div class="fon-quantity" data-multiple="6" data-qty="${ (item.quantity / 6 ) }">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${ (item.quantity / 6 ) }" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                                    </div>`
                                    }


                                </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                  case 'Weekly Billing':

                    bundleOGPrice = item.price;
                    html+=`
                      <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                      >
                        <div class="fon-line-item-wrapper">
                          <div class="fon-line-item" data-url="/products/onefit-sachets">
                            <div class="image">
                              <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/CHOC-MILKSHAKE-SACHETS_NO-BG.png?crop=center&height=300&v=1760415230&width=300" alt="">
                            </div>
                            <div class="text">
                              <h3 class="bundle-title">OneFit Weekly Plan</h3>
                              
                              <div class="lineitem-bundle-inclusions">Contents: <strong>OneFit Original: Sachets</strong> <span>Chocolate Milkshake</span>, Marathon Bottle</div>
                              <p class="price">
                                <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}/week</span>
                              </p>
                            </div>
                            <div class="action align-self-center justify-content-end">
                             

                                <div class="fon-quantity" data-qty="${item.quantity}">
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    `;
                  break;
                case 'FON Welcome Kit':

                    var fonWelcomeKitPrice = item.quantity * finalPrice;
                    var bundleSubscriptionPrice = parseFloat(item.properties._bundle_group_subscription_price) * item.quantity;

                    html+=`
                      <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                      >
                        <div class="fon-line-item-wrapper">
                          <div class="fon-line-item" data-url="/pages/welcomekit">
                            <div class="image">
                              <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/PDP_Main_Image_-_Dec23_1.jpg?crop=center&height=1500&v=1766462675&width=1500" alt="">
                            </div>
                            <div class="text">
                              <h3 class="bundle-title">OneFit 90 Day Kit</h3>
                              
                              <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${bundleInclusions}</div>
                              <p class="price">
                                <span class="price-new with-currency-code" data-item-final-price="${fonWelcomeKitPrice}">${bundleOGPrice} Today! 
                                <span class="d-block">Renews at $${bundleSubscriptionPrice}/month after first order</span>
                                </span>
                              </p>
                            </div>
                            <div class="action align-self-center justify-content-end">
                             

                                <div class="fon-quantity" data-qty="${item.quantity}">
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    `;
                  break;

                  //  <div class="fon-quantity" data-qty="1">
                  //               <button class="fon-qty-btn fon-qty-bundle-btn fon-trash-btn" data-action="minus-bundle" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                  //               </div>


                                    // <p class="price">
                                    //   <span class="price-old with-currency-code">${bundleOGPrice}</span>
                                    //   <span class="price-new with-currency-code" data-item-final-price="${bundleSalePrice}">${bundleSalePrice}</span>
                                    // </p>
                                  
          
              }
              bundlesActive.push(_bundle_group_id);
            }

            return;
            
          }

       


          if (  
                productTitle.includes("OneLife:")
            ) {
            productTitle = 'OneLife NMN Blend<span class="d-block">Watermelon</span>';
          }
         

          if (  
                productTitle.includes("OneFit:") &&
                !productTitle.includes("OneFit Plant-based:") 
            ) {
            productTitle = productTitle.replace("OneFit:","OneFit Original:");
          }
          
          if (  
                productTitle.includes("OneFit Original:") || 
                productTitle.includes("OneFit Plant-based:") || 
                productTitle.includes("OneLife:")
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();

            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }


          if (  
                productTitle == "OneFit" ||
                productTitle == "OneFit [B]" ||
                productTitle == "OneFit [B] 30-Day Supply" ||
                productTitle == "OneFit 30-Day Supply"
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'OneFit® Daily Multi-Supplement';
            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }
          if (  
                productTitle == "Comprehensive"
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'Comprehensive';
            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span><span class="fw-400">OneLife</span>`;
          }

           if (  
                productTitle == 'OneLife'
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'OneLife™ Daily Longevity Blend';
            // productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }

          

          var paymentTypeLabel = paymentType;

 
          if (paymentType == 'Ships every 30-days'){
            paymentTypeLabel = 'Monthly Delivery';

            if (!hasBundle){

              totalFrother++;
              totalBottle++;
            }


            let adjustment = item?.selling_plan_allocation?.selling_plan?.price_adjustments?.[0];

            if (adjustment) {
              let originalPrice = item.original_price / 100; // Shopify returns price in cents

              if (adjustment.value_type === 'percentage') {
                // percentage discount
                discountAmount = (originalPrice * adjustment.value) / 100;
              } else if (adjustment.value_type === 'fixed_amount') {
                // fixed amount discount (convert from cents)
                discountAmount = adjustment.value / 100;
              }
            }

            // Round up the discount amount
            discountAmount = Math.ceil(discountAmount);

          }
          

          var optionMultiplier = 1;
          var optionText = '';
          var optionTotalTake = 0;

          
          if (productTitle.includes("OneFit")) {

            let basisServe = 20;
            optionMultiplier = (paymentTypeLabel == '12-Month Supply') ? 12 : 1;
            optionTotalTake = (item.quantity * (basisServe * optionMultiplier) );

            var packageName = item.variant_title;

            // Check for 12 months
            if (productTitle.includes("Tins") || productTitle.includes("Tin")){
              packageName = 'Tins';
            }else if (productTitle.includes("Sachets") || productTitle.includes("Sachet")){
              packageName = 'Sachets';
            }else if (productTitle.includes("Pouches") || productTitle.includes("Pouch")){
              packageName = 'Pouches';
            }else{

            }

            switch (packageName){
              case 'Tins':
              case 'Pouches':
              case 'Pouch':
                optionText = `Scoops: <span>` + optionTotalTake + '</span>';
                
              break;
              case 'Sachets':
                optionText = `<span>Purchasing ` + optionTotalTake + ' Sachets</span>';
              break;
            }
          }else if (productTitle.includes("OneLife")) {

            let basisServe = 30;
            optionMultiplier = (paymentTypeLabel == '12-Month Supply') ? 12 : 1;
            optionTotalTake = (item.quantity * (basisServe * optionMultiplier) );

            optionText = `<span>Purchasing ` + optionTotalTake + ' Sachets</span>';

          }else{
            optionText = '';
          }


          if (productTitle.includes("The Starter")) {

            let cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();

            let cleanedPackaging = (item.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets';

            switch (cleanedVariantTitle){
              case 'Cacao':
              case 'French Vanilla':
                cleanedVariantTitle = `OneFit Plant-based: ${cleanedPackaging}<br>` + cleanedVariantTitle;
                break;
              default:
                cleanedVariantTitle = `OneFit Original: ${cleanedPackaging}<br>` + cleanedVariantTitle;
            }


            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;

            
            

          }


          let discountedPriceTotal = 0; //finalPrice.toFixed(2);
          let basePrice = 0; //originalPrice.toFixed(2);
          let variant;
          let sellingPlans;
          let saveTotalDiscount = 0;
          let planID;
          let productImage = item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_100x100_crop_center$1');

          const product = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));

          // let check_variant = product.variants.find(v => String(v.id) === String(item.variant_id));
          // let check_sellingPlans = check_variant.selling_plans;

          let check_variant = (product?.variants ?? []).find(
            v => String(v.id) === String(item.variant_id)
          );

          let check_sellingPlans = check_variant?.selling_plans ?? [];

     


          // Product Thumbnail
          if (product){

            let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
            if (variant){
              productImage = variant.thumbnail;
            }
          }


          if (product && !item.selling_plan_allocation){

            let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
            let sellingPlans = variant?.selling_plans || [];
            
            if (variant && sellingPlans){

              
              sellingPlans.forEach(plan => {
                let displayName = plan.name === 'Ships every 30-days' ? 'Monthly Delivery' : plan.name;
                let priceAdjustment = plan.adjustment_type;
                let isPercentage = priceAdjustment === 'percentage';
                let adjustmentValue = parseFloat(plan.price_adjustment);

                basePrice = variant.price;

                // Compute discounted price
                discountedPrice = isPercentage
                  ? basePrice - (basePrice * (adjustmentValue / 100))
                  : basePrice - adjustmentValue;

                discountedPriceTotal = (discountedPrice - (discountedPrice * (discountPercent / 100))) * item.quantity;

                

                // Round up values
                basePrice = Math.ceil(basePrice * item.quantity);
                // discountedPriceTotal = Math.ceil(discountedPriceTotal);
                // discountedPriceTotal = Math.floor(discountedPriceTotal); // Convert to floor

                // if (hasDiscount) {
                //   basePrice = parseFloat(basePrice.toFixed(2));
                //   discountedPriceTotal = parseFloat(discountedPriceTotal.toFixed(2));
                // }

                // Calculate total savings
                saveTotalDiscount = basePrice - discountedPriceTotal;

                // Optional: clean .00 for display
                // basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                // discountedPriceTotal = discountedPriceTotal % 1 === 0 ? discountedPriceTotal.toFixed(0) : discountedPriceTotal.toFixed(2);
                // saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);

                // if ($('.country-AU').length){
                //   discountedPriceTotal = discountedPriceTotal.toFixed(0);
                //   basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                //   saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                // }else{
                //   discountedPriceTotal = discountedPriceTotal.toFixed(2);
                //   basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                //   saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                // }

                discountedPriceTotal = discountedPriceTotal % 1 == 0 ? discountedPriceTotal.toFixed(0) : discountedPriceTotal.toFixed(2);
                basePrice = basePrice % 1 ===0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                saveTotalDiscount = saveTotalDiscount % 1 == 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                  
                planID = plan.id;
              });
            }
          }

          // <ul class="fon-item-properties">
          //             ${
          //               item.properties && Object.keys(item.properties).length
          //                 ? Object.entries(item.properties)
          //                     .map(([key, value]) => {
          //                       // skip properties that start with "_" or have empty values
          //                       if (value && !key.startsWith("_")) {
          //                         return `<li><strong>${key}:</strong> ${value}</li>`;
          //                       }
          //                       return "";
          //                     })
          //                     .join("")
          //                 : ``
          //             }
          //           </ul>


   

          let finalPriceUpdate = finalPrice % 1 === 0 ? finalPrice.toFixed(0) : finalPrice.toFixed(2);
          let originalPriceUpdate = originalPrice % 1 === 0 ? originalPrice.toFixed(0) : originalPrice.toFixed(2);


          var dataURL = item.url;
          if (item.properties._order_from){
            switch (item.properties._order_from){
              case 'conquesting_onefit-vs-protein':
                dataURL = '/pages/onefit-vs-protein';
              break;
              case 'conquesting_onefit-vs-collagen':
                dataURL = '/pages/onefit-vs-collagen';
              break;
              case 'onefit-main':
                dataURL = '/products/onefit';
              break;
              case 'onefit-challenger':
                dataURL = '/products/onefit-b';
              break;
              case 'onefit-short':
                dataURL = '/products/onefit-b?view=onefit-2026-b-shorter';
              break;
              case 'onefit-deal':
                dataURL = '/pages/onefit-deal';
                if (totalBottle > 0){
                  totalBottle-=1;
                }
                
              break;
              case 'conquesting_onelife-vs-nmn':
                dataURL = '/pages/onelife-vs-nmn';

                if (item.handle == 'onelife'){
                  totalBottle+=1;
                  totalFrother+=1;
                }

              break;
              case 'conquesting_onelife-vs-longevity':
                dataURL = '/pages/onelife-vs-longevity';

                if (item.handle == 'onelife'){
                  totalBottle+=1;
                  totalFrother+=1;
                }

              break;

              case 'hybrid':
                dataURL = '/pages/welcome-onelife';
              break;
              case 'b2g1':
              case 'b3g2':
                dataURL = '/pages/holiday-special';
              break;
            }
          }

          // HS
          if (productTitle == 'Holiday Special'){
            var HSVariantTitle = item.title.replace('Holiday Special - ','');
            productTitle+= '<span class="d-block" style="font-size: 10px;opacity: .5;">' + HSVariantTitle + '</span>';
          }

          html += `
            <div class="fon-line-item-row line-item-${item.variant_id} ${paymentType == '12-month Supply' ? `fon-line-item-row-12-months` : ``}" 
            
              data-variant-id="${item.variant_id}" 
              data-sku="${item.sku}" 
              data-product-id="${item.product_id}"
              data-line-key="${item.key}"
              
              >
              <div class="fon-line-item-wrapper">
                <div class="fon-line-item" data-url="${dataURL}">
                  <div class="image">
                    <img class="img-fluid" src="${productImage}" alt="${item.product_title}" />
                  </div>
                  <div class="text">
                    <h3>${productTitle}</h3>
                    
                    


                    ${hasDiscount ? `

                      ${item.selling_plan_allocation ? 
                        `<p class="monthly-subscription-save">
                          <span class="with-currency-code">${finalPriceUpdate}</span> - <span class="fon-monthly">Monthly Subscription</span>
                          </p>` 
                        : 
                        `<p class="price">
                          <span class="price-old with-currency-code">${originalPriceUpdate}</span>
                          <span class="price-new with-currency-code" data-item-final-price="${finalPrice.toFixed(2)}">${finalPriceUpdate}</span>
                        </p>
                        `
                      }

                      
                    ` : `

                      ${item.selling_plan_allocation ? 
                        `<p class="monthly-subscription-save">
                          <span class="with-currency-code">${finalPriceUpdate}</span> - <span class="fon-monthly">Monthly Subscription</span>
                          </p>` 
                        : 
                        `<p class="price">
                          <span class="price-new with-currency-code">${originalPriceUpdate}</span>
                        </p>`
                      }

                      
                      
                    `}

                

                    
                  

                  </div>
                  <div class="action align-self-center justify-content-end">
                    <div class="fon-quantity" data-qty="${item.quantity}">
                      <button class="fon-qty-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.png?v=1760332117"></span></button>
                      <button class="fon-qty-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                      <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                      <button class="fon-qty-btn" data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299"></span></button>
                    </div>
                  </div>
                </div>
                    
               
                ${ product && (item.product_title != 'OneFit') && check_variant && check_sellingPlans.length && !item.selling_plan_allocation
                  ? `
                    <div class="fon-subscribe-save-wrapperx">
                      <p class="fon-save-label">Subscribe & Save <span class="with-currency-code amount">${saveTotalDiscount}</span></p>
                      <p class="pause-anytime"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_Anytime.svg?v=1760332895" alt="Pause Anytime"/> Pause, adjust flavours, cancel any time</p>
                      <p class="prices">
                        <span class="new with-currency-code">${discountedPriceTotal}/mo</span>
                        <span class="old">vs. <span class="with-currency-code"></span>${basePrice}</span>
                      </p>
                      <button class="btn-upgrade" type="button" data-plan-id="${planID}">Upgrade now</button>
                    </div>
                    `
                  : ''
                }

              </div>

              
          `;
          html+=`<div class="fon-subscribe-save-wrapper">`;
          
          

          if (item.selling_plan_allocation ) {
            totalSubscriptionCount++;

            let subscribeSuccess = `You’re Saving With a Subscription!`;
            
            if (paymentType == '12-month Supply'){
              
              subscribeSuccess = `You’re Saving With a Subscription!`;

            }

            html+=`
                <div class="fon-line-item-subscribe-save checked">
                  <div class="fon-toggle-box subscribe-save-remove"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498"/></div>
                  <div class="fon-text">${subscribeSuccess}</div>
                </div>`;
            
  
          }

            
          // if (product && !item.selling_plan_allocation ) {

          //   html+=`
          //       <div class="fon-line-item-subscribe-save">
          //        <div class="fon-toggle-box"></div>
          //         <div class="fon-text">Subscribe & Save</div>
          //         <div class="fon-icon">?</div>
          //         <div class="fon-toggle-hover">Your products are delivered automatically based on the subscription option you choose. There’s no commitment - you can update or cancel your subscription anytime. You can also purchase subscription and one-time products in the same order. </div>
                  
          //       </div>`;
            
          //   const variant = product.variants.find(v => String(v.id) === String(item.variant_id));
          //   const sellingPlans = variant?.selling_plans || [];
    
          //   let plansHTML = '';
    
          //   sellingPlans.forEach(plan => {

          //   const displayName = plan.name === 'Ships every 30-days' ? 'Monthly Delivery' : plan.name;

          //   console.log('plan',plan);

          //   const priceAdjustment = plan.adjustment_type;
          //   const isPercentage = priceAdjustment === 'percentage';
          //   const adjustmentValue = parseFloat(plan.price_adjustment);
            
          //   const basePrice = variant.price;

          //   // Compute discounted price
          //   const discountedPrice = isPercentage
          //     ? basePrice - (basePrice * (adjustmentValue / 100) )
          //     : basePrice - adjustmentValue;

          //   let discountedPriceTotal = (discountedPrice - (discountedPrice * (discountPercent / 100) ))  * item.quantity;
            
          //   // Format "save" label
          //   // const saveLabel = isPercentage
          //   //   ? `${adjustmentValue.toFixed(0)}%`
          //   //   : `$${adjustmentValue.toFixed(2)}`;

          //   // console.log('(item.final_line_price / 100',(item.final_line_price / 100));
          //   // console.log('discountedPriceTotal',discountedPriceTotal);
              
          //   const saveLabel = (item.final_line_price / 100) - Math.floor(discountedPriceTotal);
    
          //     plansHTML += `
          //       <div class="fon-save-option " data-selling-plan-id="${plan.id}">
          //         <div class="fon-toggle-box"></div>
          //         <div class="fon-text">
          //           <p class="fon-option-title">${displayName}</p>
          //           <p class="fon-option-fon-save">Saving <span class="with-currency-code">${saveLabel}</span> Each Month</p>
          //           <ul class="fon-option-feature">

          //             <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Auto-Ships Every 30 Days</li>
          //             <li class="fon-free-bottle"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Free premium drink bottle</li>
          //             <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">VIP Early Access to new products</li>
          //             <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Pause, Update or Cancel Subscription Anytime</li>
          //             <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Best Price Guarantee</li>
          //           </ul>
          //         </div>
          //         <div class="fon-subscribe-info">
          //           <div class="fon-badge fon-badge-popular">Popular</div>
          //           <div class="new-price">$${discountedPriceTotal.toFixed(2)}/mo</div>
          //           <div class="before-after-price">
          //             <div class="before">$${basePrice.toFixed(2)}</div>
          //             <div class="after">$${discountedPrice.toFixed(2)}</div>
          //           </div>
          //         </div>
          //       </div>
          //     `;
          //   });

          //   // Disable 12 months supply - August 27, 2025
          //   // if ($('.product-onefit-12-months-supply [data-sku="'+ item.sku +'"]') && item.sku != 'BTL-01' ){

          //   //   var counterPart = $('.product-onefit-12-months-supply [data-sku="'+ item.sku +'"]');
      
          //   //   const yearLineItemPrice = originalPrice;
          //   //   const yearSupplyQuantity = item.quantity;
          //   //   const yearSupplyNoDiscount = (yearLineItemPrice * yearSupplyQuantity);
          //   //   const yearSupplyDiscounted = (yearLineItemPrice - (yearLineItemPrice * .20) );
          //   //   let yearSupplyTotal = yearSupplyDiscounted * 12;
          //   //   yearSupplyTotal = yearSupplyTotal.toFixed(2);
          //   //   const yearVariantID = counterPart.attr('data-variant-id');
          //   //   const yearSellingPlanID = counterPart.attr('data-selling-plan-id')

          //   //   const yearSupplyTotalOG = yearSupplyNoDiscount * 12;
          //   //   const yearSupplyTotalDiscount = yearSupplyTotalOG-yearSupplyTotal;
              
          //   //   const totalPriceEach = (yearLineItemPrice / item.quantity) * item.quantity * 12;
          //   //   const totalDiscountedPriceEach = (yearSupplyDiscounted / item.quantity) * item.quantity * 12;
            
          //   //   const totalDiscounted = totalPriceEach - totalDiscountedPriceEach;

          //   //   plansHTML+=`
            

          //   //     <div class="fon-save-option fon-save-option-12-months" 

          //   //       data-totalPriceEach="${totalPriceEach}"
          //   //       data-quantity="${item.quantity}"
          //   //       data-regular-price="${yearSupplyNoDiscount}"
          //   //       data-sale-price="${yearSupplyDiscounted}"
          //   //       data-variant-id="${yearVariantID}"
          //   //       data-selling-plan-id="${yearSellingPlanID}"
          //   //       data-total-year-discount="${yearSupplyTotalDiscount}"
                  
          //   //       >
          //   //       <div class="fon-toggle-box"></div>
          //   //       <div class="fon-text">
          //   //         <p class="fon-option-title">12-Month Supply</p>
          //   //         <p class="fon-option-fon-save">Saving <span class="with-currency-code">${totalDiscounted.toFixed(2)}</span></p>
          //   //         <ul class="fon-option-feature">
          //   //           <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Shipped in Quarterly Tranches</li>
          //   //           <li  class="fon-free-bottle"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Free premium drink bottle</li>
          //   //           <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">VIP Early Access to new products</li>
          //   //           <li><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498">Best Price Guarantee</li>
          //   //         </ul>
          //   //       </div>
          //   //       <div class="fon-subscribe-info">
          //   //         <div class="fon-badge fon-badge-best-value">Best Value</div>
          //   //         <div class="new-price"><span class="with-currency-code">${yearSupplyTotal}</div>
          //   //         <div class="before-after-price">
          //   //           <div class="before"><span class="with-currency-code">${yearSupplyNoDiscount}</span></div>
          //   //           <div class="after"><span class="with-currency-code">${yearSupplyDiscounted}/mo</span></div>
          //   //         </div>
          //   //         <div class="fon-after-pay-container d-none">
          //   //           <img width="132" class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Afterpay_Logo.png?v=1753846837"/>
          //   //         </div>
          //   //       </div>
          //   //     </div>
              
          //   //   `;
          //   // }
    
          //   if (plansHTML) {
          //     html += `
          //       <div class="fon-line-item-subscribe-save-options">
          //         ${plansHTML}
          //       </div>
          //     `;
          //   }
          // }
    
          html += `
              </div> <!-- close fon-subscribe-save-wrapper -->`;


          
                
          html+=`
            </div> <!-- close fon-line-item-row -->
          `;
        });

        // Free Item
          if (totalBottle > 0 && !bottleOOS){

          var totalFreeBottleSaving = totalBottle * bottlePrice;
          html += `
            <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-bottle-row">
              <div class="fon-line-item fon-line-item-free-bottle" data-total="${totalBottle}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x.png?v=1779342543" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>Free ${totalBottle}x Premium Bottle</h3>    
                  <p class="packaging">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                    <span>Free gift for subscribers</span>
                  </p>
                 
                </div>
                <div class="action">
                  <span class="free-saving with-currency-code">${totalFreeBottleSaving}</span>
                  <span class="free-badge">FREE</span>
                </div>
              </div>
            </div>`;
          }
          if (totalFrother > 0 && !frotherOOS){

          var totalFreeFrotherSaving = totalFrother * frotherPrice;
          html += `
            <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-frother-row">
              <div class="fon-line-item fon-line-item-free-frother" data-total="${totalFrother}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON-FROTHER-NO-BG_100x.png?v=1760415588" alt="Free Frother">
                </div>
                <div class="text">
                  <h3>Free ${totalFrother}x <strong>FON</strong> Frother</h3>    
                  <p class="packaging">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                    <span>Free gift for subscribers</span>
                  </p>
                </div>
                <div class="action">
                  <span class="free-saving with-currency-code">${totalFreeFrotherSaving}</span>
                  <span class="free-badge">FREE</span>
                </div>
              </div>
            </div>`;
          }


          // For Frother Savings
          if (totalOLBottle > 0 && !bottleOOS){

            var totalFreeBottleSaving = totalOLBottle * bottlePrice;
            html += `
              <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-bottle-row">
                <div class="fon-line-item fon-line-item-free-bottle-onelife" data-total="${totalOLBottle}">
                  <div class="image">
                    <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x.png?v=1779342543" alt="Free Bottle">
                  </div>
                  <div class="text">
                    <h3>Free ${totalOLBottle}x Premium Bottle</h3>    
                    <p class="packaging">
                      <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                      <span>Free gift for subscribers</span>
                    </p>
                  
                  </div>
                  <div class="action">
                    <span class="free-saving with-currency-code">${totalFreeBottleSaving}</span>
                    <span class="free-badge">FREE</span>
                  </div>
                </div>
              </div>`;
          }

          if (totalOLFrother > 0 && !frotherOOS){

          var totalFreeFrotherSaving = totalOLFrother * frotherPrice;
          html += `
            <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-frother-row">
              <div class="fon-line-item fon-line-item-free-frother-onelife" data-total="${totalOLFrother}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON-FROTHER-NO-BG_100x.png?v=1760415588" alt="Free Frother">
                </div>
                <div class="text">
                  <h3>Free ${totalOLFrother}x <strong>FON</strong> Frother</h3>    
                  <p class="packaging">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                    <span>Free gift for subscribers</span>
                  </p>
                </div>
                <div class="action">
                  <span class="free-saving with-currency-code">${totalFreeFrotherSaving}</span>
                  <span class="free-badge">FREE</span>
                </div>
              </div>
            </div>`;
          }
          // For Frother Savings

          if (totalWSWelcomeKit > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-welcome-kit" data-total="${totalWSWelcomeKit}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSWelcomeKit}x Wholesale Welcome Kit</h3>  
                </div>
              </div>
              </div>
            </div>`;
          }

          if (totalWSBottle > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-bottle" data-total="${totalWSBottle}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSBottle}x Wholesale Bottle</h3>  
                </div>
              </div>
            </div>`;
          }

          if (totalWSFrother > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-frother" data-total="${totalWSFrother}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSFrother}x Wholesale Frother</h3>  
                </div>
              </div>
            </div>`;
          }
        
        $('body').removeClass('fon-cart-drawer-empty');
        
        if (cart.items.length === 0){
           $('body').addClass('fon-cart-drawer-empty');
          html = `<div class="fon-cart-empty"><h2>Your cart is empty...</h2><a href="/collections/all" class="btn-orange">Shop now</a></div>`;
          $('body').removeClass('with-cart-items');
        }
        
        $('.fon-cart-line-items').fadeOut().html(html).fadeIn();

        // if ($('.fon-line-item-row.line-item-52349173334200').length){
        //   $('.fon-clear-cart').trigger('click');
        // }
       var kitNames = ["Welcome Kit", "OneFit 90-Day Kit","OneFit Weekly Plan","OneFit Weekly Plan"];

        if (
          $('.fon-line-item h3').filter(function () {
            return kitNames.includes($(this).text().trim());
          }).length > 0
        ) {
          $('.fon-clear-cart').trigger('click');
        }


        var cartTotal = 0;
        $.each($('[data-item-final-price]'), function() {
          var val = $(this).attr('data-item-final-price');
          console.log('Value:', val); // Debug
          cartTotal += parseFloat(val) || 0; // fallback to 0 if NaN
        });
        // $('.fon-checkout-total').html('<span class="with-currency-code">' + cartTotal.toFixed(2) + '</span>');

        // $('.fon-cart-line-items').animate({ scrollTop: 0 }, 'smooth');
        
        FonCartDrawer.updateCartCount();
        
        setTimeout( () => {
          $('body').removeClass('fon-cart-drawer-updating');
        },750);

        
      });
    }

  };

  // Optionally auto-call here (or bind later):
  $(document).ready(function () {
      // Example usage:
      FonCartDrawer.init();
      // FonCartDrawer.updateCartDrawer();
    });
  
  
    $(document).on('click', '.fon-clear-cart', function (e) {
      $('body').addClass('fon-cart-drawer-updating');
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(cart) {
          console.log('Cart cleared:', cart);
          FonCartDrawer.updateCartDrawer();
          FonCartDrawer.updateCartItem();
        },
        error: function(xhr, status, error) {
          console.error('Error clearing cart:', error);
        }
      });


    });


  $(document).on('click', '.btn-fon-checkout', function (e) {
    e.preventDefault();
  
    $('.btn-fon-checkout').text('Checking out...');
  
    // Step 1: Get current cart
    $.getJSON('/cart.js', function (cart) {
      const updates = {};
      let needsUpdate = false;
  
      cart.items.forEach(item => {
        const isSubscription = item.selling_plan_allocation !== null;
        const planName = item.selling_plan_allocation?.selling_plan?.name?.toLowerCase() || '';
  
        if (isSubscription && planName.includes('12-month')) {
          if (item.quantity !== 3) {
            updates[item.key] = 3 * item.quantity;
            needsUpdate = true;
          } else {
            updates[item.key] = item.quantity;
          }
        } else {
          updates[item.key] = item.quantity;
        }
      });


      async function handleFreeGiftClear() {
        await FonCartDrawer.awaitClearFreeItems(
          [53301741289656, 51843757670584, 51793029103800,52887363551416,53301741289656,52304276357304,52304251027640,52219844985016,53491544391864,52887363551416],
          'Free Gift'
        );

        // ONeLife Bottles 53301741289656,51843757670584

        // Subscribe (run code) once done
        console.log('Free items cleared!');
      //  alert('Free items cleared!');

        // e.g. trigger analytics or add new items
        proceedAfterUpdate();
      }

  
      // Step 2: Function to add free bottle or proceed to checkout
      function proceedAfterUpdate() {
        // if ($('.fon-line-item-free-bottle').length && !bottleOOS) {
        //   const quantity = $('.fon-line-item-free-bottle').attr('data-total') || 1;
  
        //   $.ajax({
        //     type: 'POST',
        //     url: '/cart/add.js',
        //     data: {
        //       id: '53301741289656', // Replace with actual free bottle variant ID
        //       quantity: quantity
        //     },
        //     dataType: 'json',
        //     success: function () {
        //       $('.btn-fon-checkout').text('Checkout');
        //       window.location.href = '/checkout';
        //     },
        //     error: function (error) {
        //       console.error('Add to cart failed', error);
        //       alert('Failed to add product to cart.');
        //     }
        //   });
        // } else {
        //   $('.btn-fon-checkout').text('Checkout');
        //   window.location.href = '/checkout';
        // }


        let itemsToAdd = [];

        if ($('.fon-line-item-free-bottle').length && !bottleOOS) {
          const quantity = $('.fon-line-item-free-bottle').attr('data-total') || 1;
          itemsToAdd.push({
            id: 53301741289656, // Free bottle variant ID
            quantity: quantity
          });
        }

        if ($('.fon-line-item-free-frother').length && !frotherOOS) {
          const quantity = $('.fon-line-item-free-frother').attr('data-total') || 1;
          itemsToAdd.push({
            id: 51843757670584, // Free frother variant ID
            quantity: quantity
          });
        }




        // OneLife
        if ($('.fon-line-item-free-bottle-onelife').length && !bottleOOS) {
          const quantity = $('.fon-line-item-free-bottle-onelife').attr('data-total') || 1;
          itemsToAdd.push({
            id: 53491544391864, // Free bottle variant ID
            quantity: quantity
          });
        }

        if ($('.fon-line-item-free-frother-onelife').length && !frotherOOS) {
          const quantity = $('.fon-line-item-free-frother-onelife').attr('data-total') || 1;
          itemsToAdd.push({
            id: 52887363551416, // Free frother variant ID
            quantity: quantity
          });
        }


        //WS
        if ($('.fon-line-item-ws-welcome-kit').length) {
          const quantity = $('.fon-line-item-ws-welcome-kit').attr('data-total') || 1;
          itemsToAdd.push({
            id: 52219844985016, // Free bottle variant ID
            quantity: quantity
          });
        }
        if ($('.fon-line-item-ws-bottle').length && !bottleOOS) {
          const quantity = $('.fon-line-item-ws-bottle').attr('data-total') || 1;
          itemsToAdd.push({
            id: 52304251027640, // Free bottle variant ID WS
            quantity: quantity
          });
        }
        // if ($('.fon-line-item-ws-frother').length && !frotherOOS) {
        //   const quantity = $('.fon-line-item-ws-frother').attr('data-total') || 1;
        //   itemsToAdd.push({
        //     id: 52304276357304, // Free frother variant ID WS
        //     quantity: quantity
        //   });
        // }

        // Bundle Add Ons
        if ($('.fon-cart-drawer').attr('data-bundle-bottle') !== undefined && !bottleOOS) {
          const bundleBottleQty = $('.fon-cart-drawer').attr('data-bundle-bottle') || 0;
          itemsToAdd.push({
            id: 53301741289656, // Free bottle variant ID
            quantity: bundleBottleQty
          });
        }
        if ($('.fon-cart-drawer').attr('data-bundle-frother') !== undefined && !frotherOOS) {
          const bundleFrotherQty = $('.fon-cart-drawer').attr('data-bundle-frother') || 0;
          itemsToAdd.push({
            id: 51843757670584, // Free bottle variant ID
            quantity: bundleFrotherQty
          });
        }

        if (itemsToAdd.length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: itemsToAdd }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              $('.btn-fon-checkout').text('Checkout');
              window.location.href = '/checkout';
            },
            error: function (error) {
              console.error('Add to cart failed', error);
              alert('Failed to add product(s) to cart.');
            }
          });
        } else {
          $('.btn-fon-checkout').text('Checkout');
          window.location.href = '/checkout';
        }
      }
  
      // Step 3: Update cart first if needed
      if (needsUpdate) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            handleFreeGiftClear();
          },
          error: function (err) {
            console.error('Cart update error:', err);
            alert('Failed to update cart quantities.');
          }
        });
      } else {
        handleFreeGiftClear();
      }


    });
  });


  // Bundle  Quick Add
  $(document).on('click', '.bundle-save-products .btn-quick-add', function (e) {

  

    if ($(this).hasClass('selected')){
      $(this).removeClass('selected').html('Quick Add');
    }else{
      $(this).addClass('selected').html('Selected');

      var quantitySelector = $(this).siblings('.quick-quantity-selector');
      quantitySelector.find('.quick-quantity .quantity').attr('data-value',1).html(1);

    }

     computePrice();
    computeActiveQuantityBundle();
    
  });

  $(document).on('click', '.quick-quantity-selector .quick-btn', function (e) {

    var parent = $(this).parents('.quick-quantity-selector');
    var quantity = parent.find('.quantity');
    var label = parent.find('.label');
    var action = $(this).attr('data-action');

    var total = quantity.attr('data-value');

    switch (action){
      case 'minus':
        if (total == 1){
          total--;
          quantity.attr('data-value',0).html(0);

          let buttonDefault =  parent.siblings('button').attr('data-default');
          parent.siblings('button').removeClass('selected').html(buttonDefault);
          
        }else{
          total--;
          quantity.attr('data-value',total).html(total);
        }
      break;
      case 'plus':
        total++;
        quantity.attr('data-value',total).html(total);
      break;
    }

    if (total > 1){
      
      label.html(label.attr('data-plural'));
    }else{
      label.html(label.attr('data-singular'));
    }

    computePrice();
    computeActiveQuantityBundle();

  });



  function computePrice(){

    var totalPrice = 0;
    var quantity = 0;

    $.each($('.quick-quantity-selector .quantity'),function(){

        var price = parseFloat($(this).attr('data-variant-price'));
        var qty = parseInt($(this).attr('data-value'));

        if (qty > 0){
          totalPrice+= (price * qty);
          quantity+=qty;
        }
        
        
    });

    switch (true) {
      case quantity === 2:
        totalPrice = totalPrice * 0.95;
        break;

      case quantity === 3:
        totalPrice = totalPrice * 0.90;
        break;

      case quantity >= 4:
        totalPrice = totalPrice * 0.85;
        break;

      default:
        totalPrice = totalPrice;
    }

    if (totalPrice > 0){
      $('body').addClass('bundle-selected');
      $('#btn-add-to-cart-bundle').html(`
        <span>Add to Cart</span> -
        <strong class="add-to-cart-price with-currency-code">${totalPrice.toFixed(0)}</strong>
      `);
    }else{
      $('body').removeClass('bundle-selected');
      $('#btn-add-to-cart-bundle').html(`
        <span>Add to Cart</span>
      `);
    }
    
  }



  function computeActiveQuantityBundle(){
    
   
    
    var addToCartButtonBundle = $('#btn-add-to-cart-bundle');
    var total = 0;

    // $.each($('.bundle-save-products .btn-quick-add.selected'),function(){

    //   total+= parseFloat($(this).attr('data-quantity'));
      
    // });
    $.each($('.quick-quantity-selector .quantity'),function(){
      total+= parseFloat($(this).attr('data-value'));
    });


    $('.cart-goal,.goal-progress').removeClass('matched');
    $('.cart-goal,.goal-progress').removeClass('active');
    $('.cart-goal,.goal-progress').removeClass('last-matched');
    
    $('.cart-goal,.goal-progress').each(function (index) {
      var spendValue = parseInt($(this).attr('data-quantity'), 10);
    
      if (total >= spendValue) {
        $(this).addClass('matched'); // optional: add class to highlight
      }
    });

    var lastMatched = $('.goals .cart-goal.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it

    var lastMatched = $('.goals-progress > div.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it
    
    $(".goals,.goals-progress").attr('data-matched',$('.cart-goal').length);

    // Jan 12 - Dynamic Pricing
    $('.buying-widget-052025').removeClass('with-tier-discounts');
    if (total >= 1){
      
      var discountTier = total+1;
      discountTier = (total >= 4) ? 4 : discountTier;


      $.each($('.btn-quick-add'),function(){
        $(this).addClass('discounted-price');
        var discountedPriceValue = $(this).attr('data-variant-tier-'+discountTier+'-price');
        // $(this).append(`
        //   <span class="discounted-price-value">$${discountedPriceValue}</span>
        // `);
        $(this).find('strong').html('$'+discountedPriceValue);
      });

      $('.buying-widget-052025').addClass('with-tier-discounts'); 
    }else{
      $.each($('.btn-quick-add'),function(){
        var discountedPriceValue = $(this).attr('data-variant-price');
        $(this).removeClass('discounted-price').find('strong').html('$'+discountedPriceValue);
      });
      // $('.discounted-price-value').remove();
    }
    // Jan 12 - Dynamic Pricing -- END

    if (total > 0){
      addToCartButtonBundle.prop('disabled',false);
    }else{
      addToCartButtonBundle.prop('disabled',true);
    }
    
  }
  
  $(document).on('click', '#btn-add-to-cart-bundle', function (e) {
    addToCartBundle();
  });

  function addToCartBundle(){

    
     var addToCartButton = $('#btn-add-to-cart-bundle');
    addToCartButton.html('Please wait..').prop('disabled',true);
        var items = [];
    

    $.each($('.quick-quantity-selector .quantity'),function(){

      var variantId = $(this).data('variant-id');
      var qty =  parseFloat($(this).attr('data-value'));
    
      if (variantId && qty > 0) {
        items.push({
          id: variantId,
          quantity: qty
        });
      }
    });
    // $.each($('.bundle-save-products .btn-quick-add.selected'),function(){
    //   var variantId = $(this).data('variant-id');
    //   var qty = 1;
      
    //   if (variantId) {
    //     items.push({
    //       id: variantId,
    //       quantity: qty
    //     });
    //   }
    // });
    
    if (items.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: items
        },
        dataType: 'json',
        success: function(response) {
          console.log('Items added:', response);

          FonCartDrawer.openCartDrawer();
          FonCartDrawer.updateCartDrawer();
          addToCartButton.html('Add To Cart').prop('disabled',false);
          computePrice();
          
          
        },
        error: function(error) {
          console.error('Error adding items:', error);
          addToCartButton.html('Something went wrong...').prop('disabled',false);
        }
      });
    }
  }
  
  

  $(document).on('click', '.fbt-add-to-cart', function (e) {
    e.preventDefault();
  
    var $button = $(this);
    var variantId = $button.data('variant-id');
  
    // Prevent multiple clicks
    if ($button.prop('disabled')) return;
  
    $button.prop('disabled', true).addClass('loading');
    


    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (response) {
        console.log('Added to cart:', response);
        FonCartDrawer.updateCartDrawer();
        $button.html('<img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498"> Added').addClass('added');

        setTimeout(function(){
          $button.html('<img loading="lazy" alt="Add product" title="Add product" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Group_3.png?v=1759909299">').removeClass('added').prop('disabled', false);
        },2000);
      },
      error: function (error) {
        console.error('Add to cart error:', error);
        alert('Sorry, could not add this item.');
        $button.prop('disabled', false).removeClass('loading');
      }
    });
  });

  $(document).on('click', '.fon-line-item .image img, .fon-line-item h3', function() {
    // Find the closest .fon-line-item container
    var item = $(this).closest('.fon-line-item');
    
    // Get the data-url attribute
    var url = item.data('url');

    // Redirect if the URL exists
    if (url) {
        window.location.href = url;
    }
});
  

})(jQuery);
